<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Epigraph</a></p>
<p class="toc sub"><a href="#/front03">Map of Journey</a></p>
<p class="part"><a href="#/c001">Part One</a></p>
<p class="toc"><a href="#/c01">A telephone call at dawn</a></p>
<p class="toc"><a href="#/c02">The red-haired professor</a></p>
<p class="toc"><a href="#/c03">Prelude</a></p>
<p class="toc"><a href="#/c04">The snowball</a></p>
<p class="toc"><a href="#/c05">There’s no one so silly as a clever man</a></p>
<p class="toc"><a href="#/c06">My last year</a></p>
<p class="toc"><a href="#/c07">Life counted in minutes</a></p>
<p class="toc"><a href="#/c08">The year 1937 begins</a></p>
<p class="toc"><a href="#/c09">Expelled from the Party</a></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">That day</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">Captain Vevers</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">The cellars at “Black Lake”</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">The investigators have conclusive evidence</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">Stick and carrot</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">The walls come to life</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">“Can you forgive me?”</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">The “conveyor belt”</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">Confrontations</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">Parting</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">New encounters</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">Orphans twice over</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">Tukhachevsky and others</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">To Moscow</span></p>
<p class="toc"><span href="#/c24" title="Link target outside of Sample">Transfer</span></p>
<p class="toc"><span href="#/c25" title="Link target outside of Sample">Introduction to Butyrki</span></p>
<p class="toc"><span href="#/c26" title="Link target outside of Sample">The whole of the Comintern</span></p>
<p class="toc"><span href="#/c27" title="Link target outside of Sample">Butyrki nights</span></p>
<p class="toc"><span href="#/c28" title="Link target outside of Sample">In accordance with the law of December 1st</span></p>
<p class="toc"><span href="#/c29" title="Link target outside of Sample">“A fair and speedy trial”</span></p>
<p class="toc"><span href="#/c30" title="Link target outside of Sample">Penal servitude—what bliss!</span></p>
<p class="toc"><span href="#/c31" title="Link target outside of Sample">The Pugachev Tower</span></p>
<p class="toc"><span href="#/c32" title="Link target outside of Sample">The Stolypin coach</span></p>
<p class="toc"><span href="#/c33" title="Link target outside of Sample">Five steps by three</span></p>
<p class="toc"><span href="#/c34" title="Link target outside of Sample">Major Weinstock’s twenty-two commandments</span></p>
<p class="toc"><span href="#/c35" title="Link target outside of Sample">Bright nights and dark days</span></p>
<p class="toc"><span href="#/c36" title="Link target outside of Sample">Captain Glands dog</span></p>
<p class="toc"><span href="#/c37" title="Link target outside of Sample">The underground punishment cell</span></p>
<p class="toc"><span href="#/c38" title="Link target outside of Sample">Comunista Italiana</span></p>
<p class="toc"><span href="#/c39" title="Link target outside of Sample">“Next year in Jerusalem”</span></p>
<p class="toc"><span href="#/c40" title="Link target outside of Sample">Day after day, month after month</span></p>
<p class="toc"><span href="#/c41" title="Link target outside of Sample">A breath of oxygen</span></p>
<p class="toc"><span href="#/c42" title="Link target outside of Sample">A fire in prison</span></p>
<p class="toc"><span href="#/c43" title="Link target outside of Sample">Punishment cell for the second time</span></p>
<p class="toc"><span href="#/c44" title="Link target outside of Sample">Memories of Giordano Bruno</span></p>
<p class="toc"><span href="#/c45" title="Link target outside of Sample">The end of the “monstrous dwarf”</span></p>
<p class="toc"><span href="#/c46" title="Link target outside of Sample">Great expectations</span></p>
<p class="toc"><span href="#/c47" title="Link target outside of Sample">A bathhouse! Just an ordinary bathhouse!</span></p>
<p class="toc"><span href="#/c48" title="Link target outside of Sample">The ruins of Schlüsselburg</span></p>
<p class="part"><span href="#/c002" title="Link target outside of Sample">Part Two</span></p>
<p class="toc"><span href="#/c49" title="Link target outside of Sample">Car Number 7</span></p>
<p class="toc"><span href="#/c50" title="Link target outside of Sample">All sorts to make a world</span></p>
<p class="toc"><span href="#/c51" title="Link target outside of Sample">The transit camp</span></p>
<p class="toc"><span href="#/c52" title="Link target outside of Sample"><em>The</em> S.S. Dzhurma</span></p>
<p class="toc"><span href="#/c53" title="Link target outside of Sample">No luck today, my lady Death!</span></p>
<p class="toc"><span href="#/c54" title="Link target outside of Sample">Light work</span></p>
<p class="toc"><span href="#/c55" title="Link target outside of Sample">Elgen is the Yakut word for “dead”</span></p>
<p class="toc"><span href="#/c56" title="Link target outside of Sample">Tree felling</span></p>
<p class="toc"><span href="#/c57" title="Link target outside of Sample">Salvation from heaven</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Connect with HMH</span></p>
<p class="toc sub"><span href="#/footnotes" title="Link target outside of Sample">Footnotes</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?353a614d